// extracted by mini-css-extract-plugin
module.exports = {"button":"da51a739f7--button--x8P2q","button-left":"da51a739f7--button-left--CVnpz","button-right":"da51a739f7--button-right--eccQk"};